import { useEffect, useState } from "preact/hooks";

export interface CurrentDay {
    year: number;
    month: number;
    day: number;
}

function getCurrentDay(): CurrentDay {
    const now = new Date();
    return {
        year: now.getFullYear(),
        month: now.getMonth(),
        day: now.getDate(),
    };
}

function getMsUntilMidnight(): number {
    const now = new Date();
    const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    return midnight.getTime() - now.getTime();
}

export function useCurrentDay(): CurrentDay {
    const [currentDay, setCurrentDay] = useState(getCurrentDay);

    useEffect(() => {
        let timeoutId: ReturnType<typeof setTimeout>;

        function scheduleUpdate() {
            const msUntilMidnight = getMsUntilMidnight();
            timeoutId = setTimeout(() => {
                setCurrentDay(getCurrentDay());
                scheduleUpdate();
            }, msUntilMidnight);
        }

        scheduleUpdate();

        return () => clearTimeout(timeoutId);
    }, []);

    return currentDay;
}